class snThumbControls extends HTMLElement{
    #stateAttr = 'playing';
    #observer = null;
    constructor() {
        super();
    }
    get playControls(){
        return this.querySelector('hdt-slider-play');
    }
    get currentVideo(){
        return this.closest('hdt-slideshow')?.querySelector('.hdt-slideshow__slide.is-selected video');
    }
    get currentThumbVideo(){
        return this.closest('hdt-slideshow')?.querySelector('.is-thumb-selected video');
    }

    connectedCallback(){
        setTimeout(() => this.init(), 0);
    }
    init(){
        this.playControls.addEventListener('click',this.handleClick.bind(this));
    }
    handleClick(e){
        if(this.playControls.hasAttribute(this.#stateAttr)){
            this.playActiveVideos();
        }else{
            this.pauseAllVideos();
        }
        
    }
    async #safePlay(video) {
        if (!video || typeof video.play !== 'function') return;
        
        try {
            if (video.paused) {
                await video.play();
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error("Playing video:", error);
            }
        }
    }

    playActiveVideos() {
        const video = this.currentVideo;
        const thumbVideo = this.currentThumbVideo;

        if (video) this.#safePlay(video);
        if (thumbVideo) this.#safePlay(thumbVideo);
    }

    pauseAllVideos() {
        const video = this.currentVideo;
        const thumbVideo = this.currentThumbVideo;

        if (video && !video.paused) video.pause();
        if (thumbVideo && !thumbVideo.paused) thumbVideo.pause();
    }

    disconnectedCallback() {
        if (this.#observer) {
            this.#observer.disconnect();
        }
    }
}
customElements.define('sn-slideshow-controls', snThumbControls);